import { FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import './Contact.css';

const CONTACTS = [
  {
    icon: <FiLinkedin aria-hidden="true" />,
    label: 'LinkedIn',
    handle: 'mckendree-strommer',
    href: 'https://www.linkedin.com/in/mckendree-strommer-957070122',
  },
  {
    icon: <FiGithub aria-hidden="true" />,
    label: 'GitHub',
    handle: 'Windowmac',
    href: 'https://github.com/Windowmac',
  },
  {
    icon: <FiMail aria-hidden="true" />,
    label: 'Email',
    handle: 'mckendree.strommer@gmail.com',
    href: 'mailto:mckendree.strommer@gmail.com',
  },
];

const Contact = () => {
  const headerRef = useScrollReveal();
  const cardsRef  = useScrollReveal();

  return (
    <section id="contact" className="contact" aria-label="Contact">
      <div className="section-container">
        <div className="section-header reveal" ref={headerRef}>
          <p className="section-label">Get In Touch</p>
          <h2 className="section-title">Let's Connect</h2>
          <p className="contact__subtitle">
            Always open to interesting projects, collaborations, or just a good conversation
            about engineering and AI. Reach out through any of these channels.
          </p>
        </div>

        <div className="contact__cards reveal" ref={cardsRef}>
          {CONTACTS.map(({ icon, label, handle, href }, i) => (
            <a
              key={label}
              href={href}
              target={href.startsWith('mailto') ? undefined : '_blank'}
              rel={href.startsWith('mailto') ? undefined : 'noreferrer'}
              className="contact__card"
              style={{ transitionDelay: `${i * 0.1}s` }}
              aria-label={`${label}: ${handle}`}
            >
              <span className="contact__card-icon">{icon}</span>
              <div className="contact__card-text">
                <p className="contact__card-label">{label}</p>
                <p className="contact__card-handle">{handle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
